var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.4163 0.587831C22.1962 1.37001 22.1943 2.63634 21.4122 3.41625L4.83252 19.9481L21.4122 36.4799C22.1943 37.2598 22.1962 38.5261 21.4163 39.3083C20.6363 40.0905 19.37 40.0923 18.5878 39.3124L0.587831 21.3643C0.211508 20.9891 0 20.4795 0 19.9481C0 19.4166 0.211508 18.9071 0.587831 18.5318L18.5878 0.583745C19.37 -0.196174 20.6363 -0.194345 21.4163 0.587831Z","fill":"#737C98"}));
}

ArrowLeft.defaultProps = {"width":"22","height":"40","viewBox":"0 0 22 40","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
